import { DumbbellIcon } from './DumbbellIcon';

/**
 * author: Google
 * id E792948B-8E66-49B5-83E7-8CDF1ECE6C5D
 * name dumbbell
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dumbbell.svg
 * tags
 * - Sport 
 */
export const FitnessCenterIcon = DumbbellIcon;
export default FitnessCenterIcon